import { render, staticRenderFns } from "./EventUser.vue?vue&type=template&id=1763671d&scoped=true"
import script from "./EventUser.vue?vue&type=script&lang=js"
export * from "./EventUser.vue?vue&type=script&lang=js"
import style0 from "./EventUser.vue?vue&type=style&index=0&id=1763671d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1763671d",
  null
  
)

export default component.exports